const skills = {
  1: [
    {
      title: "HTML 5",
      level: 6,
    },
    {
      title: "CSS 3",
      level: 5,
    },
    {
      title: "JavaScript",
      level: 4,
    },
    {
      title: "TypeScript",
      level: 4,
    },
    {
      title: "Tailwind CSS",
      level: 5,
    },
    {
      title: "React JS",
      level: 5,
    },
    {
      title: "Figma",
      level: 4,
    },
  ],
  2: [
    {
      title: "Node JS",
      level: 5,
    },
    {
      title: "Express Js",
      level: 4,
    },
    {
      title: "MongoDB",
      level: 2,
    },
    {
      title: "Git",
      level: 4,
    },
    {
      title: "Mongoose",
      level: 4,
    },
    {
      title: "MySQL",
      level: 2,
    },
    {
      title: "C#",
      level: 2,
    },
  ],
  3:[
    {
      title: "Ms Office",
      level: 5,
    },
    {
      title: "preparation",
      level: 4,
    },
    {
      title: "Analicies",
      level: 4,
    },
    {
      title: "Time management",
      level: 4,
    },
    {
      title: "Team Work",
      level: 5,
    },
    {
      title: "Hard Work",
      level: 5,
    },
  ]
};

export default skills;
